import { AxiosError } from 'axios'
import { ApiProvider } from '../provider'
import { APIRoutes } from '../routes'
import { SettingsType } from 'api/types/portal'

class Portal {
  // get a setting by code
  async getConfig({
    code,
  }: {
    code: string
  }): Promise<SettingsType | (AxiosError | Error)> {
    const url = `${APIRoutes.portal.getConfig}?code=${code}`
    return ApiProvider.getRequest(url) as Promise<
      SettingsType | (AxiosError | Error)
    >
  }

  // get all settings
  async getConfigList(): Promise<SettingsType[] | (AxiosError | Error)> {
    const url = APIRoutes.portal.getConfigList
    return ApiProvider.getRequest(url) as Promise<
      SettingsType[] | (AxiosError | Error)
    >
  }

  async saveConfig({
    code,
    value,
  }: {
    code: string
    value: string
  }): Promise<any | (AxiosError | Error)> {
    const url = `${APIRoutes.portal.saveConfig}?code=${code}&value=${value}`
    return ApiProvider.postRequest(url, {}, false) as Promise<
      any | (AxiosError | Error)
    >
  }

  async saveConfigList(
    body: SettingsType[],
  ): Promise<any | (AxiosError | Error)> {
    const url = `${APIRoutes.portal.saveConfigList}`
    return ApiProvider.postRequest(url, body, false) as Promise<
      any | (AxiosError | Error)
    >
  }
}

export const portalService = new Portal()
